module.exports = __webpack_public_path__ + "e5e5e397d9e7e40f3b3078e291e3b396.svg";